module.exports = __webpack_public_path__ + "img/sicepatnew.20a20f74.png";